import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";
import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.from.js";
var _effectorFileName = "/builds/gmini/front-common/src/classifier-editor/SelectDependencies/ModelsTree/node/node.ts";

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.reduce.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.values.js";
import { combine, createStore, merge, sample } from 'effector';
import * as smApi from '@gmini/sm-api-sdk';
import { clone, isEmpty, prop } from 'ramda';
import { adapter } from "./adapter";
export function createSelectDepsStoreService(notification, currentEntity$) {
  var getModelOrFolder = merge([smApi.NavigationModelRepoFolder.fetchRootFolders.doneData, smApi.NavigationModelRepoFolder.fetchFolderContent.doneData], {
    name: "getModelOrFolder",
    sid: "-lddzgl"
  });
  var modelUpdateEvent = merge([smApi.BimModel.fetchLatestBimFile.doneData, notification.filter({
    fn: smApi.NotificationEvent.Update.is
  }).map(prop('payload')).filter({
    fn: smApi.BimFile.isBimFile
  })], {
    name: "modelUpdateEvent",
    sid: "nb5oaa"
  });
  var rootNodes$ = createStore([], {
    name: "rootNodes$",
    sid: "8fqlm4"
  }).on(smApi.NavigationModelRepoFolder.fetchRootFolders.doneData, function (_, result) {
    return result.list.map(adapter);
  });
  var bimFile$ = createStore({}, {
    name: "bimFile$",
    sid: "5au8ho"
  }).on(getModelOrFolder, function (state, result) {
    return result.list.filter(function (item) {
      return smApi.NavigationBimFile.isBimFile(item) || smApi.NavigationBimFile.isGStationBimFile(item);
    }).map(adapter).reduce(function (acc, node) {
      var bimFileNode = node; // TODO костыль для типизации. Это безопасно, фильтр выше исключает возможность попадания сюда других нод

      acc[node.urn] = bimFileNode;
      return acc;
    }, state);
  }).on(modelUpdateEvent, function (state, bimFile) {
    var next = clone(state);
    next[bimFile.urn] = _objectSpread(_objectSpread({}, next[bimFile.urn]), adapter(bimFile));
    return next;
  });
  var modelRepositoryFolder$ = createStore({}, {
    name: "modelRepositoryFolder$",
    sid: "-o47l6p"
  }).on(getModelOrFolder, function (state, result) {
    var next = clone(state);
    result.list.filter(function (item) {
      return smApi.NavigationModelRepoFolder.isBim360ModelRepositoryFolder(item) || smApi.NavigationModelRepoFolder.isGStationModelRepositoryFolder(item);
    }).map(adapter).forEach(function (node) {
      next[node.urn] = node; // TODO костыль для типизации. Это безопасно, фильтр выше исключает возможность попадания сюда других нод
    });
    return next;
  });
  sample({
    ɔ: [{
      clock: smApi.BimFile.Import.done,
      source: [bimFile$, currentEntity$],
      fn: function fn(_ref, _ref2) {
        var _ref3 = _slicedToArray(_ref, 2),
            bimFiles = _ref3[0],
            currentEntity = _ref3[1];

        var params = _ref2.params;
        var model = bimFiles[params.bimFileUrn];
        return {
          parentFolderUrn: model === null || model === void 0 ? void 0 : model.parentFolderUrn,
          projectUrn: currentEntity === null || currentEntity === void 0 ? void 0 : currentEntity.projectUrn
        };
      }
    }],
    config: {
      sid: "2z029u"
    }
  }).watch(function (_ref4) {
    var parentFolderUrn = _ref4.parentFolderUrn,
        projectUrn = _ref4.projectUrn;

    if (!projectUrn) {
      return;
    }

    if (parentFolderUrn) {
      smApi.NavigationModelRepoFolder.fetchFolderContent.defaultContext({
        folderUrn: parentFolderUrn,
        projectUrn: projectUrn
      });
      return;
    }

    smApi.NavigationModelRepoFolder.fetchRootFolders.defaultContext({
      projectUrn: projectUrn
    });
  });
  var flatNodes$ = combine({
    ɔ: [{
      modelRepositoryFolder: modelRepositoryFolder$,
      nBimFile: bimFile$
    }, function (nodes) {
      var flatNodes = Object.values(nodes).filter(function (obj) {
        return !isEmpty(obj);
      }).reduce(function (acc, nodeMap) {
        Object.values(nodeMap).forEach(function (node) {
          return acc.push(node);
        });
        return acc;
      }, []);
      return flatNodes;
    }],
    config: {
      name: "flatNodes$",
      sid: "-wwu0id"
    }
  });
  return {
    rootNodes$: rootNodes$,
    flatNodes$: flatNodes$,
    bimFile$: bimFile$
  };
}